import moment from "moment";
import PropTypes from "prop-types";
import { DatePicker, Input, Radio } from "top-component-library";
import { DAY_LABELS, DAY_ORDER, ORDER_RATE_LIMIT_SCHEDULE_PLACEHOLDER } from "../constants";
import { DayField, StackedButtonGroup, WizardFieldRow } from "../styles";

const toMoment = (isoDate) => (isoDate ? moment(isoDate) : null);
const toIsoDate = (momentValue) => (momentValue ? momentValue.format("YYYY-MM-DD") : null);

const OrderRateLimitScheduleStep = ({
  showActiveSchedule,
  startDate,
  endDate,
  activeSchedule,
  onChangeShowActiveSchedule,
  onChangeStartDate,
  onChangeEndDate,
  onChangeDay,
}) => (
  <div>
    <h4>Would you like to Limit Dates/Times?</h4>
    <Radio.Group value={showActiveSchedule} onChange={(event) => onChangeShowActiveSchedule(event.target.value)}>
      <StackedButtonGroup>
        <Radio value>Yes</Radio>
        <Radio value={false}>No</Radio>
      </StackedButtonGroup>
    </Radio.Group>
    {showActiveSchedule && (
      <div>
        <h4>Dates:</h4>
        <small>Leave blank to apply all the time</small>
        <WizardFieldRow style={{ alignItems: "center", marginTop: 12 }}>
          <DatePicker
            placeholder="Start Date"
            value={toMoment(startDate)}
            onChange={(value) => onChangeStartDate(toIsoDate(value))}
          />
          <span>TO</span>
          <DatePicker
            placeholder="End Date"
            value={toMoment(endDate)}
            onChange={(value) => onChangeEndDate(toIsoDate(value))}
          />
        </WizardFieldRow>
        <h4>Days of Week:</h4>
        <small>
          Leave blank to apply all the time (or 12AM-12AM). Type CLOSED if limitation should not be enforced for that
          day of the week.
        </small>
        <div style={{ marginTop: 12 }}>
          {DAY_ORDER.map((day) => (
            <DayField key={day}>
              <label htmlFor={`throttle-schedule-${day}`}>{DAY_LABELS[day]}</label>
              <Input
                id={`throttle-schedule-${day}`}
                placeholder={ORDER_RATE_LIMIT_SCHEDULE_PLACEHOLDER}
                value={activeSchedule[day]?.customer_input || ""}
                onChange={(event) => onChangeDay(day, event.target.value)}
              />
            </DayField>
          ))}
        </div>
      </div>
    )}
  </div>
);

OrderRateLimitScheduleStep.propTypes = {
  showActiveSchedule: PropTypes.bool.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  activeSchedule: PropTypes.objectOf(PropTypes.shape({ customer_input: PropTypes.string })).isRequired,
  onChangeShowActiveSchedule: PropTypes.func.isRequired,
  onChangeStartDate: PropTypes.func.isRequired,
  onChangeEndDate: PropTypes.func.isRequired,
  onChangeDay: PropTypes.func.isRequired,
};

OrderRateLimitScheduleStep.defaultProps = {
  startDate: null,
  endDate: null,
};

export default OrderRateLimitScheduleStep;
